<template>
    <div>
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10 '/>
        <BreadCrumbsComponent :breadcrumbs="breadcrumbs" class="margin-breadcrumb mt-180"/>
        <div class='px-md-16 mx-5 mx-sm-10 mx-md-10 mx-md-16 my-6'>
            <h1 class="orange--text font-title"><i>Estudios médicos</i></h1>
            <div class="gray--text mt-8 font-text">
                Con el respaldo de nuestra infraestructura de vanguardia podrá realizarse los siguientes estudios:
            </div>
            <div class='pt-8 px-0'>
                <v-col class='col-md-4 px-0'>
                    <v-text-field
                        label="Escriba el nombre del estudio"
                        outlined
                        dense
                        rounded
                        class='search-profile font-title'
                        v-model=name
                        @keydown.enter="medicalStudiesExams"
                    >
                        <template v-slot:append >
                            <v-icon >mdi-magnify</v-icon> 
                            <span 
                                class='blue--text mt-1' 
                                @click="medicalStudiesExams" 
                                style="cursor:pointer"
                            >
                                Buscar
                            </span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="study == null">
                    <v-list v-if="studies.length">
                        <v-list-item 
                            style="border-bottom: 1px dashed;height: 20px;padding: 0;"
                            v-for="(p, x) in studies"
                            :key=x
                        >
                            <v-list-item-content>
                                <v-list-item-title  
                                    class='gray--text font-weight-medium font-title'
                                    @click="searchMedicalStudies(p.product_id)"
                                    style='cursor:pointer'
                                >
                                    {{p.product_name}}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action >
                                <v-btn text link class='blue--text font-title' @click="searchMedicalStudies(p.product_id)">
                                    <v-icon>mdi-eye</v-icon> Ver <span class='d-none d-sm-block'>información</span>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                        <v-pagination
                            class='mt-10'
                            v-model=currentPage
                            :length=totalItems
                            @input="handlePageChange"
                            total-visible="10"
                        ></v-pagination>
                    </v-list>
                    <v-col class='text-center text-md-h5 gray--text ' v-else>
                        <div class='icon-not-found'>
                            <img :src="`${require('@/assets/Ups.png')}`" ><span>Ups...</span>
                        </div>
                        No se encontró ningún resultado de estudio médico
                    </v-col>
                </v-col>
                <v-row v-else>
                    <v-col cols="12">
                        <v-list >
                            <v-list-item  style="border-bottom: 1px dashed;height: 20px;padding: 0;">
                                <v-list-item-content>
                                    <v-list-item-title  class='gray--text font-weight-bold'>{{study.product_name}}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action >
                                    <v-btn text link class='blue--text font-title' @click="study=null">
                                        <v-icon>mdi-format-list-bulleted</v-icon> <span class='d-none d-sm-block mr-md-2'>Ver </span> listado
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col cols="12" sm=6 >
                        <v-card class='rounded-lg '>
                            <div class="primary white--text text-center text-md-h6 font-weight-bold">
                                PREPARACIÓN
                            </div>
                            <v-container fluid class="text-center gray--text font-weight-medium text-md-h6">
                                {{!!study.requisito ? study.requisito : 'xxxxxxxxxxxxx'}}
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm=6 class='mb-4'>
                        <v-card class='rounded-lg'>
                            <div class="primary white--text text-center text-md-h6 font-weight-medium">
                                DÓNDE REALIZARLO
                            </div>
                            <v-container fluid class="text-center gray--text font-weight-bold text-md-h6">
                                <v-btn 
                                    text 
                                    class="blue--text font-weight-medium font-title px-0" 
                                    style="letter-spacing: .5px;"
                                    @click=centroApp
                                >
                                    Centro de aplicaciones
                                </v-btn> 
                                / 
                                <v-btn 
                                    text 
                                    class="blue--text font-weight-medium font-title px-0" 
                                    style="letter-spacing: .5px;"
                                    @click=domicilioApp
                                >
                                    Domicilio
                                </v-btn>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm=6 class='mb-4'>
                        <v-card class='rounded-lg'>
                            <div class="primary white--text text-center text-md-h6 font-weight-bold">
                                ÓRDEN MÉDICA
                            </div>
                            <v-container fluid class="text-center gray--text font-weight-medium text-md-h6">
                                {{study.receta ? 'Requiere':  'No requiere'}}  una órden de su médico
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm=6 class='mb-4'>
                        <v-card class='rounded-lg'>
                            <div class="primary white--text text-center text-md-h6 font-weight-bold">
                                TURNO
                            </div>
                            <v-container fluid class="text-center gray--text font-weight-medium  text-md-h6">
                                Debe 
                                <v-btn 
                                    text 
                                    class="blue--text  px-0" 
                                    style="letter-spacing: .5px;"
                                    @click=requestTurn
                                > 
                                    solicitar turno 
                                </v-btn>  previo
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm=6 class='mb-4'>
                        <v-card class='rounded-lg'>
                            <div class="primary white--text text-center text-md-h6 font-weight-bold">
                                ENTREGA DE RESULTADOS
                            </div>
                            <v-container fluid class="text-center gray--text font-weight-medium text-md-h6">
                                {{!!study.tiempo_respuesta_desc ? study.tiempo_respuesta_desc : 'xxxxxxxxxxxxx'}}
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
            <v-dialog
                v-model="dialog"
                width="500"
                persistent
            >
                <v-card>
                    <v-card-title class="text-right pb-0" style="display: block;">               
                        <v-btn
                            color="primary"
                            text
                            x-small
                            class="gray--text"
                            @click="dialog = false"
                        >
                            <v-icon small>mdi-close</v-icon>  Cerrar
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <img v-if="imgDialog!=''" :src="`${require('@/assets/'+imgDialog)}`" width="90px">
                        <div v-html=content></div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
     </div>
</template>

<script>

import {mapActions, mapMutations} from 'vuex'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'

export default {
    name:'MedicalStudiesComponent',
    components:{
        MenuMovilComponent,
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
    },
    data: ()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Estudios médicos', url:'/estudios-medicos'}
        ],
        study:null,
        studies:[],
        name:null,
        results:null,
        totalItems:1,
        currentPage:1,
        itemsPerPage:10,
        dialog:false,
        content:'',
        imgDialog:''
    }),
    computed:{

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

    },
    methods:{

        ...mapMutations(['setUrl','setLoadingTable']),

        ...mapActions(['requestApi']),

        handlePageChange(value) {
            this.currentPage = value;
            this.medicalStudiesExams()
        },

        medicalStudiesExams(){

            if(this.currentPage!=1 && this.name!=null && this.name!='')
                this.currentPage=1
                
            this.study=null
            this.setUrl('estudios-examanes')
            this.requestApi({
				method: 'GET',
				data :{
                    page:this.currentPage,
                    itemsPerPage: 10,
                    name: this.name
                }
			}).then(res =>{
               
                this.totalItems = res.data.page_count
                this.studies = res.data._embedded.estudios_examanes
			})
        },

        searchMedicalStudies(idProfile){
            this.setUrl('estudios-examanes/'+idProfile)
            this.requestApi({
				method: 'GET',
				data :{}
			}).then(res =>{
               this.study= res.data.study
			})
        },

        centroApp(){
            this.imgDialog='lab-aplicaciones.png'
            this.dialog = true
            this.content="<div class='text-md-h6 font-weight-regular' style='line-height:1'>Puede realizarse este análisis en nuestros centros de aplicaciones:</div>"
            this.content+="<div class='mt-3' ><a class='blue--text text-md-h6' href='/sedes/centro-aplicaciones-quito'>Centro de aplicaciones (sede Quito)</a></div>"
            this.content+="<div class='mt-2'><a class='blue--text text-md-h6' href='/sedes/centro-aplicaciones-guayaquil'>Centro de aplicaciones (sede Guayaquil)</a></div>"
        },

        domicilioApp(){
            this.imgDialog='Laboratorio-envios.png'
            this.dialog = true
            this.content="<div class='text-md-h6 font-weight-regular' style='line-height:1'>Puede realizarse este análisis en su domicilio. <br /> Solicite un turno en nuestras lineas telefónicas brindando la información necesaria.</div>"
            
        },

        requestTurn(){
            this.icow = require('@/assets/whatsapp-verde.png')
            this.imgDialog='llamadas.png'
            this.dialog = true
            this.content="<div class='text-md-h6 font-weight-regular' style='line-height:1'>Para solicitar un turno comuníquese con nosotros a los siguientes numeros:</div>"
            this.content+="<div class='text-md-h5 mt-5 primary--text font-weight-black font-italic'>Llámenos al <a href='telf:02510070'>(02) 5 100 700</a></div>"
            this.content+="<div class='text-md-h5  font-weight-black font-italic'><img src="+this.icow+" style='width:30px;position:relative;top:7px'><a class='blue--text' target='_blank' href='https://api.whatsapp.com/send?phone=+593991342224'>099 134 2224</a></div>"
        },
        
    },
    created(){
        this.$emit('newBreadcrumbs',this.breadcrumbs)
        this.medicalStudiesExams()
    }
}
</script>

<style>
    .tab-inactive{
        border: 2px solid #7fe0b6;
        border-radius: 8px;
        color:#7fe0b6!important;
        font-size: 20px;
        font-weight: 900;
    }

    .tab-active{
        border-radius: 8px;
        border: 2px solid #50c995!important;
        color:#50c995!important;
    }

    .v-slide-group__prev{
        display: none!important;
    }
    div.search-profile .v-input__slot fieldset{
        border:2px solid #26aeea!important
    }

    div.search-profile .v-input__slot .v-icon, .v-text-field__slot label.v-label--active      {
        color:#26aeea!important;
        
    }

    div.search-profile .v-text-field__slot label.v-label{
        font-style: italic;
    }

    div.rounded-lg div.container{
        border: 2px solid #50c995;
    }

    div.icon-not-found img{
        width: 90px;
    }

    div.icon-not-found span{
        position: relative;
        bottom: 33px
    }

    .v-application .text-md-h5, .v-application .text-md-h6{
        font-family: Asap!important;
    }

    @media(max-width: 700px){
        .tab-inactive{
           
            font-size: 17px;
            
        }
    }
</style>